import axios from 'axios';

const apiClient = axios.create({
  baseURL: 'https://api.mysfs24.com/api/', // Replace with your actual API base URL
});

export default apiClient;